import { ButtonStyleCheckbox, ButtonStyleCheckboxGroup, TextInput } from '@uplift/ui-v2';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';
import { useQuery } from '@tanstack/react-query';
import { getGenders } from '@uplift/api';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { ProfileForm } from './types';
import { useProfileStyles } from '../styles';

export type GenderFormProps = {
  hideLabel?: boolean;
  includePreferNotToSay?: boolean;
};

export const GENDER_SELF_DESCRIBE_ID = 'selfDescribe';

const getGenderLabel = (name: string) => {
  switch (name) {
    case 'Cisgender man':
      return `${name} (born and identify as a man)`;
    case 'Cisgender woman':
      return `${name} (born and identify as a woman)`;
    default:
      return name;
  }
};

export const GenderForm: React.VFC<GenderFormProps> = props => {
  const { data: genders = [] } = useQuery(PROFILE_ROW_QUERY_KEYS.gender, async () => {
    const response = await getGenders();

    return response.data;
  });
  const { classes } = useProfileStyles();
  const formik = useFormikContext<ProfileForm['gender']>();

  const otherGenderInput = useMemo(() => {
    if (formik.values.genders.includes(GENDER_SELF_DESCRIBE_ID)) {
      return (
        <TextInput
          name="otherGender"
          fullWidth
          className={classes.maxWidth400}
          color="secondary"
        />
      );
    }
    return null;
  }, [ formik.values.genders, classes ]);

  const genderOptions = useMemo(() => {
    return [
      ...genders.map((g) => ({ label: getGenderLabel(g.name), value: g.id })),
      { label: 'Prefer to self-describe', value: GENDER_SELF_DESCRIBE_ID }
    ];
  }, [ genders ]);

  return (
    <div>
      <ButtonStyleCheckboxGroup label={props.hideLabel ? undefined : '(Optional)'} name="genders">
        {genderOptions.map(option => (
          <ButtonStyleCheckbox
            label={option.label}
            value={option.value}
            key={option.value}
          />
        ))}
      </ButtonStyleCheckboxGroup>
      {otherGenderInput}
    </div>
  );
};
